import { PageContentNotAllowed } from 'pages';
import React from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoutePropsType } from './types';

export const ProtectedRouteContentNotAllowed: React.FunctionComponent<ProtectedRoutePropsType> =
  ({ path }) => {
    return (
      <Route path={path}>
        <PageContentNotAllowed />
      </Route>
    );
  };
